import { render, staticRenderFns } from "./VideoCallList.vue?vue&type=template&id=a47ed724&"
import script from "./VideoCallList.vue?vue&type=script&lang=js&"
export * from "./VideoCallList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports